'use client';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import cn from 'classnames';
import { ChevronIcon } from '@/assets/icons/ChevronIcon';
import { Testimonial, TestimonialProps } from '@/ui-components/molecules/Testimonial/Testimonial';
import styles from './testimonialscarouselgroup.module.scss';
import { responsiveBreakpointsPx } from '@/constants';
import type { Options as SplideOptions } from '@splidejs/splide';

export interface TestimonialsCarouselGroupProps {
    testimonials: TestimonialProps[];
}

export default function TestimonialsCarouselGroup({ testimonials }: TestimonialsCarouselGroupProps): React.JSX.Element {
    const sliderOptions: SplideOptions = {
        rewind: false,
        type: 'slide',
        gap: 16,
        pagination: false,
        omitEnd: true,
        mediaQuery: 'min',
        arrows: false,
        fixedWidth: '237px',
        breakpoints: {
            [responsiveBreakpointsPx.md]: {
                fixedWidth: '264px',
            },
            [responsiveBreakpointsPx.lg]: {
                arrows: true,
                drag: false,
                fixedWidth: '100%',
            },
        },
    } as const;

    return (
        <div className={styles.wrapper}>
            <Splide options={sliderOptions} hasTrack={false}>
                <div className={`splide__arrows ${styles.carouselArrows}`}>
                    <button
                        className={cn('splide__arrow splide__arrow--prev', styles.leftArrow)}
                        aria-label={`Carousel navigate previous arrow`}
                    >
                        <ChevronIcon />
                    </button>

                    <button
                        className={cn('splide__arrow splide__arrow--next', styles.rightArrow)}
                        aria-label={`Carousel navigate next arrow`}
                    >
                        <ChevronIcon />
                    </button>
                </div>

                <SplideTrack className={styles.slideTrack}>
                    {testimonials.map((testimonial, index) => (
                        <SplideSlide key={index}>
                            <div className={styles.slideWrapper}>
                                <Testimonial {...testimonial} excludeResponsiveSizes={['lg']} />
                            </div>
                        </SplideSlide>
                    ))}
                </SplideTrack>
            </Splide>
        </div>
    );
}
